export enum VideoUploadShareOptions {
  USERS = "users",
  COMPANY = "company",
  PROJECT = "project",
}
